import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertTemplateFieldsMutation, InsertTemplateFieldsMutationVariables } from '@/graphql/generated/graphql';
import { InsertTemplateFieldsDocument } from '@/graphql/generated/graphql';
export type TemplateFieldInsertInput = {
  OrganizationIds?: string[]
  ScreenId?: string
  Name?: string
  Label?: string
  Type?: string
  Required?: boolean
  Placeholder?: string
  HelpText?: string
  Options?: string[]
  Order?: number
  AiSuggestionEnabled?: boolean
  AiSuggestionKey?: string
  UilmHelpTextKey?: string
  UilmLabelKey?: string
  UilmOptionsKeys?: string[]
  UilmPlaceholderKey?: string
  Conditions?: string
}

export type InsertTemplateFieldResponse = {
  data: {
    insertTemplateFields: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertTemplateField = () => {
  const mutation = useMutation({
    mutationKey: ['insert-template-field'],
    mutationFn: (variables: TemplateFieldInsertInput) => {
      return graphqlClient.request<InsertTemplateFieldsMutation>(InsertTemplateFieldsDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertTemplateField: mutation.mutate,
    insertTemplateFieldAsync: mutation.mutateAsync,
  }
}

export const INSERT_TEMPLATE_FIELD_MUTATION = InsertTemplateFieldsDocument;
